export type EventData = {
  id: number;
  title: string;
  date?: string;
  month: string;
  day: string;
  location: string;
  time?: string;
  description?: string;
  url?: string;
  /** Set to true once the event is complete so it moves into Past Events */
  isPast?: boolean;
  /** Set to true to hide from EventsSection without deleting the entry */
  isHidden?: boolean;
  /** Optional ISO date (YYYY-MM-DD) for reliable sorting/filtering */
  sortDate?: string;
};

export const eventsData: EventData[] = [
  {
    id: 1,
    title: "Project Ontario - Province-Wide Kickoff",
    date: "TBD",
    month: "TBD",
    day: "-",
    location: "Virtual Event",
    time: "Details Coming Soon",
    description:
      "Join us for the official launch of Project Ontario - a province-wide initiative to address the most pressing issues facing our communities.",
    url: "", // Add URL here when available
    sortDate: "2026-08-01",
    isHidden: true,
  },
  {
    id: 2,
    title: "Pints & Principles",
    date: "July 8, 2026",
    month: "JUL",
    day: "08",
    location: "Toronto (central), venue details to be announced",
    time: "5pm to late",
    url: "https://luma.com/project-9r6z",
    sortDate: "2026-07-08",
  },
  {
    id: 3,
    title: "Education Reform - Our Kids Deserve Better",
    date: "Tuesday, March 10",
    month: "MAR",
    day: "10",
    location: "Royal Canadian Military Institute, Toronto, Ontario",
    time: "5:30 p.m. - 8:30 p.m.",
    description:
      "A discussion on education reform and how we can improve outcomes for all Ontario students.",
    url: "https://luma.com/kz9fv1yk",
    sortDate: "2026-03-10",
  },
  {
    id: 4,
    title: "Drug Policy Reform - No More \"Safe Supply\"",
    date: "November 26",
    month: "NOV",
    day: "26",
    location: "National Club (Toronto)",
    time: "6-9pm",
    description:
      "Join us for an important conversation about drug policy reform and alternatives to failed safe supply programs.",
    url: "https://www.eventbrite.ca/e/tell-doug-no-more-safe-supply-tickets-1964181443572",
    sortDate: "2025-11-26",
  },
  {
    id: 5,
    title: "Conservative Renewal in Ontario",
    date: "December 3",
    month: "DEC",
    day: "03",
    location: "Cardus, Ottawa (45 Rideau St)",
    time: "6-9pm",
    description:
      "Connect with Project Ontario supporters in Ottawa and help shape our next steps.",
    url: "https://luma.com/yegjzycw",
    sortDate: "2025-12-03",
  },
];
